import React, { useEffect, useState, useRef } from "react";
import close from "../../assets/images/close.svg";
import { Col, Form, Nav, Row, Tab } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../../services/APIRoute";
import { apiCall } from "../../services/AxiosService";
import { apiResponse } from "../../services/APIResponse";
import { commonservices } from "../../services/CommonServices";
import {
    default as infobtn,
    default as infoIcon,
} from "../../assets/images/infobtnblue.svg";
import { useDispatch } from "react-redux";
import { GetList } from "../../services/ReduxTookit/Slice/IndustryRedux";
import {
    GetWorkspaceListByID,
    WorkflowTagSearch,
} from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import { toast } from "react-toastify";
import CustomSelect from "../ConfigurationComponent/CustomSelect";

function AddProjectPopup({ handleshowPopup, activeTab }) {
    const [descriptionError, setDescriptionError] = useState(false);
    // const handleTabClick = (tabIndex) => {
    //   setActiveTab(tabIndex);
    // };
    const navigate = useNavigate();
    let dispatch = useDispatch();
    const [IndustryList, setIndustryList] = useState([]);
    const location = useLocation();
    const [showDropdown, setShowDropdown] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const debounceRef = useRef(null);
    const [workspaceListOpt, setWorkspaceListOpt] = useState([]);
    const [workspaceInput, setWorkspaceInput] = useState([]);
    const [input, setInput] = useState({
        industrytype: "",
        projectname: "",
        description: "",
        aiEnchance: "",
        tags: "",
        workspace: "",
        errors: {
            industrytype: "",
            projectname: "",
            workspace: "",
            ValidationRules: [
                {
                    FieldName: "workspace",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "industrytype",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
                {
                    FieldName: "projectname",
                    ValidationType: "required",
                    ValidationMessage: "This Field is a required field",
                },
            ],
        },
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInput((prevState) => ({
            ...prevState,
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: "",
            },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let allData = { ...input };
        let obj = commonservices.fnCheckValidationOfObject(allData);

        if (allData?.aiEnchance && allData?.description?.length < 250) {
            if (allData?.errors) {
                allData.errors.description = "250 characters description require";
            }

            setInput(allData);
            return;
        } else {
            allData.errors.description = "";
        }
        setInput({
            ...obj.obj,
        });
        if (obj.isValid) {
            // Condition Apply only in beta environment. As discussed with satish/Ashish
            if (API_URL.BASEURL.includes("beta")) {
                const workFlowName = input?.projectname; // ?.trim();
                if (
                    !workFlowName ||
                    workFlowName.substring(0, 5).toLowerCase() !== "beta-" // must start with beta
                ) {
                    toast.error("Workflow Name must start with 'beta-'.");
                    return;
                }
            }

            if (input?.projectname.toLowerCase().indexOf("sandbox") >= 0) {
                toast.error("The keyword 'SANDBOX' is not allowed in workflow names.");
                return;
            }

            let data = commonservices.bodyEncryption(
                `0?v=0&r=${location?.pathname?.includes("/dashboard")
                    ? activeTab
                        ? "dc"
                        : "dl"
                    : activeTab
                        ? "wc"
                        : "wl"
                }`,
            );
            navigate(`/flow-new/${data}`, {
                state: {
                    industrytype: input?.industrytype,
                    projectname: input?.projectname?.trim(),
                    aiEnchance: input?.aiEnchance,
                    description: input?.description,
                    isViewMode: false,
                    tag: input?.tag,
                    workspaceInput: workspaceInput,
                    workspaceListOpt: workspaceListOpt,
                },
            });
            handleshowPopup(e);
        }
    };

    async function getIndustryList() {
        let body = {
            industryname: "",
        };
        dispatch(GetList(body)).then((res) => {
            if (res?.payload?.isValidate) {
                setIndustryList(res?.payload?.data?.data);
            } else {
            }
        });

        // -------------- Before redux
        // let resData = await apiCall(
        //   {
        //     method: "POST",
        //     url: API_URL.BASEURL + API_URL.INDUSTRYGETLIST,
        //     body: body,
        //   },
        //   true
        // );
        // let response = apiResponse(false, resData);
        // if (response?.isValidate) {
        //   setIndustryList(response?.data?.data);
        // }
        // if (!response?.isValidate) {
        // }
    }
    const isSelectingRef = useRef(false);
    const getLastSearchText = (value) => {
        const parts = value.split(",");
        return parts[parts.length - 1].trim();
    };

    const getSelectedTags = (value) => {
        return value
            .split(",")
            .slice(0, -1)
            .map((t) => t.trim().toLowerCase())
            .filter(Boolean);
    };

    const getLastToken = (value) => value.split(",").pop().trim().toLowerCase();

    const fetchTags = async (searchText) => {
        if (!searchText || searchText.length < 2) {
            setSuggestions([]);
            setShowDropdown(false);
            return;
        }

        try {
            // Example API
            let body = {
                search: searchText,
            };
            dispatch(WorkflowTagSearch(body)).then((res) => {
                if (res?.payload?.isValidate) {
                    const selectedTags = getSelectedTags(input.tag);
                    const filteredTags = (res?.payload?.data?.data?.dataList1 || [])
                        .map((x) => x.tag)
                        .filter((tag) => !selectedTags.includes(tag.toLowerCase()));
                    setSuggestions(filteredTags);
                } else {
                    setSuggestions([]);
                }
            });

            setShowDropdown(true);
        } catch (err) {
            console.error("Tag search failed", err);
        }
    };

    const handleTagChange = (e) => {
        const val = e.target.value;
        const regEx = /^[a-z0-9,\- ]*$/i; // allow comma

        if (val !== "" && !regEx.test(val)) return;

        const selectedTags = getSelectedTags(val);
        const lastToken = getLastToken(val);

        // Block typing if last token already exists
        if (lastToken && selectedTags.includes(lastToken)) {
            return;
        }
        setInput((prev) => ({
            ...prev,
            tag: val,
        }));
    };

    useEffect(() => {
        if (isSelectingRef.current) {
            isSelectingRef.current = false; // reset flag
            return;
        }
        const fullText = input.tag;
        if (!fullText) {
            setSuggestions([]);
            setShowDropdown(false);
            return;
        }
        const searchText = getLastSearchText(fullText);

        if (!searchText || searchText.length < 2) {
            setSuggestions([]);
            return;
        }

        clearTimeout(debounceRef.current);

        debounceRef.current = setTimeout(() => {
            fetchTags(searchText); // ONLY last token
        }, 400);

        return () => clearTimeout(debounceRef.current);
    }, [input.tag]);

    const handleSelectTag = (selectedTag) => {
        isSelectingRef.current = true;
        setInput((prev) => {
            const parts = prev.tag.split(",");

            // Replace last typed value
            parts[parts.length - 1] = ` ${selectedTag}`;

            return {
                ...prev,
                tag: parts.join(",").replace(/^ /, ""),
            };
        });

        setSuggestions([]);
    };

    const fetchWorkspaceList = () => {
        dispatch(GetWorkspaceListByID(0))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.length > 0) {
                    let _WorkspaceOpt = [];
                    response?.payload?.data?.data.forEach((element) => {
                        _WorkspaceOpt.push({
                            value: element?.workspacename,
                            label: element?.workspacename,
                        });
                    });
                    setWorkspaceListOpt(_WorkspaceOpt);
                }
            }
            if (!response?.payload?.isValidate) {
            }
        });
    };

    useEffect(() => {
        fetchWorkspaceList();
        getIndustryList();
    }, []);
    return (
        <Tab.Container
            id="left-tabs-example"
            defaultActiveKey="first"
            className="underlined-tabing"
        >
            <div className="schedular-popup add-project-popup addworkflowpopup">
                <div className="popup-title">
                    <h2>Add Workflow</h2>
                    <img
                        src={close}
                        alt="close"
                        id="add-project"
                        className="cursor-pointer"
                        onClick={(e) => {
                            handleshowPopup(e);
                        }}
                    />
                </div>
                <div className="d-block p-0">
                    {/* <Nav variant="pills" className="justifly-content-start">
            <Nav.Item>
              <Nav.Link eventKey="first">Details</Nav.Link>
            </Nav.Item> */}
                    {/* <Nav.Item>
              <Nav.Link eventKey="second">Workflow</Nav.Link>
            </Nav.Item> */}
                    {/* <Nav.Item>
              <Nav.Link eventKey="third">Schedule</Nav.Link>
            </Nav.Item> */}
                    {/* </Nav> */}
                </div>
                <div className="popup-body">
                    <Tab.Content>
                        <Tab.Pane eventKey="first">
                            <Row>
                                <Col xl={12}>
                                    <Form.Group className="form-group mb-2">
                                        <Form.Label className="common-label">
                                            Industry Types
                                            <span className="ms-1 red-color-text">*</span>
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Select
                                                className="common-select"
                                                // onChange={(e) => {
                                                //   setInput({ ...input, industrytype: e.target.value });
                                                // }}
                                                name="industrytype"
                                                onChange={handleInputChange}
                                                isInvalid={input?.errors?.industrytype}
                                            >
                                                <option value={""}>Select</option>
                                                {IndustryList?.length > 0 &&
                                                    IndustryList?.map((item) => {
                                                        return (
                                                            <option
                                                                key={item?.industryid}
                                                                value={
                                                                    item?.industryid + "/" + item?.industryname
                                                                }
                                                            >
                                                                {item?.industryname}
                                                            </option>
                                                        );
                                                    })}
                                                {/* <option value="2">Retail Store</option>
                      <option value="3">Tours & Travels</option> */}
                                            </Form.Select>
                                            {input?.errors?.industrytype && (
                                                <Form.Control.Feedback type="invalid">
                                                    <span className="error-message-icon">
                                                        <img
                                                            src={infoIcon}
                                                            alt="infoIcon"
                                                            title={input?.errors?.industrytype}
                                                        />
                                                    </span>
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="form-group mb-2">
                                        <Form.Label className="common-label">
                                            Workflow Name
                                            <span className="ms-1 red-color-text">*</span>
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type="text"
                                                placeholder="Workflow Name"
                                                className="common-input"
                                                name="projectname"
                                                maxLength={50}
                                                value={input?.projectname}
                                                // onChange={(e) =>
                                                //   setInput({ ...input, projectname: e.target.value })
                                                // }
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    // const regEx = /^[a-z0-9 ]*$/i;
                                                    const regEx = /^[a-z0-9\- ]*$/i;
                                                    const isValid = regEx.test(val);

                                                    if (val === "") {
                                                        // setInput({ ...input, projectname: "" });
                                                        handleInputChange(e);
                                                    } else if (isValid) {
                                                        // setInput({ ...input, projectname: val });
                                                        handleInputChange(e);
                                                    }
                                                }}
                                                isInvalid={input?.errors?.projectname}
                                            />
                                            {input?.errors?.projectname && (
                                                <Form.Control.Feedback type="invalid">
                                                    <span className="error-message-icon">
                                                        <img
                                                            src={infoIcon}
                                                            alt="infoIcon"
                                                            title={input?.errors?.projectname}
                                                        />
                                                    </span>
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    </Form.Group>

                                    {/* Work Space */}
                                    <Form.Group className="form-group mb16">
                                        <Form.Label className="common-label">
                                            Workspace <span className="ms-1 red-color-text">*</span>
                                        </Form.Label>

                                        <div
                                            className={`${input?.errors?.workspace ? "error-border-line" : ""}`}
                                        >
                                            <CustomSelect
                                                isMulti
                                                isCreatable
                                                placeholder="Start typing to add Workspace's.."
                                                options={workspaceListOpt}
                                                setOptions={setWorkspaceListOpt}
                                                value={workspaceInput}
                                                setValue={setWorkspaceInput}
                                                // Below Para. is for need value in modal's internal state
                                                name="workspace"
                                                input={input}
                                                setInput={setInput}
                                            />
                                        </div>
                                    </Form.Group>

                                    {/*  */}

                                    <Form.Group className="form-group mb-2">
                                        <Form.Label className="common-label">
                                            Tag
                                            {/* <span className="ms-1 red-color-text">*</span> */}
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type="text"
                                                placeholder="Tag"
                                                className="common-input"
                                                name="tag"
                                                maxLength={50}
                                                value={input?.tag}
                                                onChange={handleTagChange}
                                                isInvalid={input?.errors?.tag}
                                            />

                                            {showDropdown && suggestions.length > 0 && (
                                                <div className="autocomplete-dropdown">
                                                    {suggestions.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className="autocomplete-item"
                                                            onClick={() => handleSelectTag(item)}
                                                        >
                                                            {item}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {input?.errors?.tag && (
                                                <Form.Control.Feedback type="invalid">
                                                    <span className="error-message-icon">
                                                        <img
                                                            src={infoIcon}
                                                            alt="infoIcon"
                                                            title={input?.errors?.tag}
                                                        />
                                                    </span>
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="form-group mb-2">
                                        <Form.Label className="common-label">
                                            Description
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                style={{ minHeight: "120px" }}
                                                as="textarea"
                                                rows={5}
                                                placeholder="Description"
                                                className="common-input"
                                                maxLength={499}
                                                onChange={(e) =>
                                                    setInput({ ...input, description: e.target.value })
                                                }
                                                isInvalid={input?.errors?.description}
                                            />
                                            {input?.errors?.description && (
                                                <Form.Control.Feedback type="invalid">
                                                    <span className="error-message-icon">
                                                        <img
                                                            src={infoIcon}
                                                            alt="infoIcon"
                                                            title={input?.errors?.description}
                                                        />
                                                    </span>
                                                </Form.Control.Feedback>
                                            )}
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="ms-1 common-label">
                                {" "}
                                <input
                                    type="checkbox"
                                    id="aienhance"
                                    onClick={() => {
                                        if (!input?.aiEnchance) {
                                            setInput({ ...input, aiEnchance: true });
                                        } else {
                                            setInput({ ...input, aiEnchance: false });
                                        }
                                    }}
                                />{" "}
                                <label for="aienhance">Apply AI Enhancement</label>
                                {input?.aiEnchance && (
                                    <p style={{ color: "red" }}>
                                        (Minimum 250 characters description require)
                                    </p>
                                )}
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
                </div>
                <div className="popup-footer">
                    <button
                        className="grey-btn"
                        id="add-project"
                        onClick={(e) => {
                            handleshowPopup(e);
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="blue-btn"
                        onClick={(e) => {
                            // handleshowPopup(e);
                            handleSubmit(e);
                        }}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </Tab.Container>
    );
}

export default AddProjectPopup;
